import { EditOutlined } from '@mui/icons-material'
import { IconButton, Stack, Tooltip, Typography } from '@mui/material'
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-premium'
import { PropsWithChildren, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { checkAndStartCellEditMode } from './utils/CheckAndSetMode'

interface EditableTextCellProps extends PropsWithChildren, GridRenderEditCellParams {
  disabled?: boolean
  isFirst?: boolean
  tooltip?: string
}

export const EditableTextCell = ({ id, value, field, children, disabled, tooltip }: EditableTextCellProps) => {
  const apiRef = useGridApiContext()
  const [showEditButton, setShowEditButton] = useState(false)
  const { t } = useTranslation('shared')

  return (
    <Stack
      direction="row"
      gap={0}
      alignItems="center"
      width="100%"
      onMouseEnter={() => setShowEditButton(true)}
      onMouseLeave={() => setShowEditButton(false)}
    >
      {children ? (
        children
      ) : (
        <Typography
          variant="Body14pxRegular"
          sx={{
            p: 1,
            ml: '-4px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {value}
        </Typography>
      )}
      {showEditButton && !disabled && (
        <Tooltip title={tooltip ?? t('table-filters.actions.rename')}>
          <IconButton
            sx={{ height: 25, width: 25 }}
            onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()
              checkAndStartCellEditMode(apiRef, id, field)
            }}
            data-testid="edit-cell-button"
          >
            <EditOutlined sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  )
}
